import { useCallback } from "react";

import type { OptionPmsItemCreateInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import * as Query from "../../query";
import * as Schema from "../schema";

export const useOptionPmsItemCreateMutation = () => {
	const { mutationFunc } = useCustomMutation(Schema.OPTION_PMS_ITEM_CREATE_FOR_OPTION_PMS_MUTATION);

	const onCreateOptionPmsItem = useCallback(
		async (input: OptionPmsItemCreateInput) =>
			await mutationFunc({
				variables: { input },
				refetchQueries: [Query.Schema.OPTION_PMS_ACTIVE_LIST_FOR_OPTION_PMS],
			}),
		[mutationFunc],
	);

	return { onCreateOptionPmsItem };
};
